<template>
  <Breadcrumbs
      title="Stock Return Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Stock Return Report', path: '/stock-return-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <stockReturn />
    </div>
  </div>
</template>

<script>
import stockReturn from './stock_return_report_table.vue';
export default {
  name: 'indexList',
  components: {
    stockReturn
  },
}
</script>